@let assistantSlideoutOpen = assistants.assistantSlideoutOpenSg();
@let processSlideoutOpen = processesFeature.selectors.isSlideoutOpen.asSignal();
@let currentUser = meFeature.selectors.currentUser.asSignal();

<div
  class="atn-navbar-footer"
  #sidebarFooter
>
  @if (checkInFeature.selectors.eligibleForDailyCheckIn.asSignal()) {
    <atn-navbar-footer-item
      #checkInItem="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="notice-me"
      (click)="
        checkInFeature.actions.startCheckIn
          .from('Navbar.CheckIn.Clicked')
          .dispatch({ origin: checkInItem })
      "
      name="Daily Check-In"
      icon="write"
    ></atn-navbar-footer-item>
  }
  <!-- TODO Currently not used. This should be visible only when there are some
  items that are copied  -->
  <!-- <atn-navbar-footer-item
    (click)="openClipboard($event)"
    name="Clipboard"
    icon="clipboard"
  ></atn-navbar-footer-item> -->
  <atn-navbar-footer-item
    (click)="openProcessSlideout()"
    name="Processes"
    icon="processes"
    data-test-id="sidbar-processes-button"
  ></atn-navbar-footer-item>
  <atn-navbar-footer-item
    (click)="copyContext()"
    name="Copy Context"
    icon="clipboard"
  ></atn-navbar-footer-item>
  <atn-navbar-footer-item
    (click)="
      fileMgmtFeature.actions.displayFinder
        .from('Navbar.Files.Icon.Clicked')
        .dispatch('toggle')
    "
    name="Files"
    icon="folder"
  >
    <!-- TODO: move this below when we get rid of the feature flag -->
    <atn-file-finder [origin]="sidebarFooter" />
  </atn-navbar-footer-item>
  <atn-navbar-footer-item
    (click)="assistants.assistantSlideoutOpenSg.set(!assistantSlideoutOpen)"
    name="Assistant"
    icon="comment"
  ></atn-navbar-footer-item>
  @if (apiKeys.canAccessSg()) {
    <atn-navbar-footer-item
      (click)="apiKeysSlideoutOpenSg.set(!apiKeysSlideoutOpenSg())"
      name="API Access"
      icon="unlock"
      data-test-id="sidebar-api-access-button"
    ></atn-navbar-footer-item>
  }
  <atn-navbar-footer-item
    [externalUrl]="docsUrl"
    name="User Guides"
    icon="book"
    suffixIcon="open"
  ></atn-navbar-footer-item>
  <atn-navbar-footer-item
    (click)="showLogOutConfirmationSg.set(true)"
    name="Log Out"
    icon="log-out"
  ></atn-navbar-footer-item>
</div>

@if (processSlideoutOpen) {
  <atn-process-slideout />
}
@if (assistantSlideoutOpen) {
  <atn-assistant-slideout
    (close)="assistants.assistantSlideoutOpenSg.set(false)"
  />
}
@if (apiKeysSlideoutOpenSg()) {
  <atn-api-keys-slideout (close)="apiKeysSlideoutOpenSg.set(false)" />
}

@if (showLogOutConfirmationSg()) {
  <atn-ds-confirmation-overlay
    title="Log Out"
    description="Are you sure you want to log out?"
    (cancel)="showLogOutConfirmationSg.set(false)"
    (confirm)="signOut()"
    confirmButtonText="Log Out"
  >
    <ng-container details>
      @if (currentUser) {
        <div class="atn-navbar-footer__log-out-account">
          Account: {{ currentUser.name }}, {{ currentUser.email }}
        </div>
      }
    </ng-container>
  </atn-ds-confirmation-overlay>
}
